import { render } from "./ExpenseView.vue?vue&type=template&id=70bcb80b"
import script from "./ExpenseView.vue?vue&type=script&lang=js"
export * from "./ExpenseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__